<template>
  <div>
    <!-- <HeaderNavbar /> -->
    <el-row>
      <HeaderNavbar :activeIndex="'4'" />
    </el-row>
    <el-row>
      <ReportsTimeline />
    </el-row>
    <el-row>
      <HFooter />
    </el-row>
  </div>
</template>
<style scoped>
.el-header {
  padding: 0;
}
.el-main {
  padding: 0;
}
</style>
<script>
// @ is an alias to /src
import HeaderNavbar from "@/components/HeaderNavbar.vue";
import HFooter from "@/components/HFooter.vue";
import ReportsTimeline from "@/components/Reports/ReportsTimeline.vue";
export default {
  name: "Home",
  components: {
    HeaderNavbar,
    HFooter,
    ReportsTimeline,
  },
};
</script>
